export default __webpack_public_path__ + "static/avatar-andy-gray2-5efdbf2888c1c23695a7c557bc2cba82.png";